module.exports = __webpack_public_path__ + "static/08-9b123e5e4a5895d885788db7c35b6814.jpg";